module.exports = __webpack_public_path__ + "img/voya.d54f9ae6.png";